import "@sourceflow-uk/job-search/dist/bundle.css";
import ArrowRight from "@/assets/ArrowRight.svg";
import JobSearch from "@sourceflow-uk/job-search";
import JobType from "@/../.sourceflow/jobs-Job Type.json";
import Sector from "@/../.sourceflow/jobs-Sector.json";
import Specialities from "@/../.sourceflow/jobs-Speciality.json";
import Salaries from "@/../.sourceflow/jobs-Salary.json";
import Region from "@/../.sourceflow/jobs-Regions.json"
import Consultants from "@/../.sourceflow/jobs-Consultant (UK version).json";
import PropTypes from "prop-types";
import { Container, FormCheck, Stack } from "react-bootstrap";
import { CTA } from "@/ui";
import classes from "./styles.module.scss";
import clsx from "classnames";
import { formatDistanceToNowStrict } from "date-fns";

export const JobsFeed = ({ className, changeURLOnFilterChange }) => {
  return (
    <div className={clsx(className, classes.feed)}>
      <Container>
        <JobSearch
          options={{
            jobsUrl: "/jobs/",
            urlFilters: {
              mode: "active",
              jobCategories: [JobType, Sector, Specialities, Salaries, Consultants, Region],
              changeURLOnFilterChange: changeURLOnFilterChange,
            },
            searchInput: {
              queryInput: true,
              locationInput: true,
              radiusInput: true,
            },
            searchFiltersOptions: {
              showResetSearchButton: true,
              topLevelCategoryOrder: ["Branches", "Job Type", "Sector", "Speciality", "Salary", "Consultant (UK version)","Region"], // filters will appear in this order
              filterUnselectedElement: <FormCheck />,
              filterSelectedElement: <FormCheck checked />,
              exclude: {
                Client: true,
                Currency: true,
                Grade: true,
                Groups: true,
              },
            },
            searchResultsOptions: {
              resultNewTab: false,
              resultLinks: ({ href, label, target, job }) => (
                <>
                  <time className="me-auto">{`Posted ${formatDistanceToNowStrict(
                    new Date(job.published_at * 1000),
                  )} ago`}</time>
                  <CTA href={href} label={label} target={target} variant="tertiary" />
                  <CTA href={`${href}#Apply`} label="Apply now" target={target} variant="outline-tertiary" />
                </>
              ),
            },
          }}
          translations={{
            "searchResults.buttonText": "View job",
            "button.text": (
              <Stack className="flex-row align-items-center justify-content-center px-3" gap={2}>
                Search <ArrowRight />
              </Stack>
            ),
          }}
        />
      </Container>
    </div>
  );
}

JobsFeed.defaultProps = {
  className: "py-4 py-md-5",
  sector: null,
  changeURLOnFilterChange: true,
};

JobsFeed.propTypes = {
  className: PropTypes.string,
  sector: PropTypes.string,
};

export default JobsFeed;
